var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{attrs:{"href":_vm.storeLink,"alt":_vm.altText}},[_c('img',{staticStyle:{"width":"120px","height":"36px"},attrs:{"src":_vm.imageLocation,"alt":_vm.altText}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }